import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage-four',
  templateUrl: './homepage-four.component.html',
  styleUrls: ['./homepage-four.component.scss']
})
export class HomepageFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
